import React, { Component } from 'react';

export default class Header extends Component {
  render() {
    return (
      <React.Fragment>
      {
		<header id="home">			
			<nav id="nav-wrap">
				<a class="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
				<a class="mobile-btn" href="#" title="Hide navigation">Hide navigation</a>

				 <ul id="nav" class="nav">
					<li class="current"><a class="smoothscroll" href="#home">Home</a></li>
					<li><a class="smoothscroll" href="#about">About</a></li>
					 <li><a class="smoothscroll" href="#resume">Resume</a></li>
					<li><a class="smoothscroll" href="#portfolio">Portfolio</a></li>
					<li><a class="smoothscroll" href="#testimonials">Testimonials</a></li>
					<li><a class="smoothscroll" href="#contact">Contact</a></li>
				 </ul> 
			</nav> 

			<div class="row banner">
				<div class="banner-text">
					<h1 class="responsive-headline">I'm Gabriele Cassano.</h1>					
					<h3 style={{ color: '#FFFFFF', fontWeight:'bold' }}>I'm a <span style={{ color: '#FFFF00'}}>Web Developer</span>, <span style={{ color: '#FFFF00'}}>from Strépy-Bracquegnies</span> and <span style={{ color: '#FFFF00'}}>MySQL database manager</span> developping websistes
					in HTML5, CSS3, PHP, JavaScript, jQuery. I use too Angular, Symfony2, Zend, Laravel framework and WordPress, Drupal, Joomla, Prestashop CMS.
					Click here to access <a class="smoothscroll" href="#about">about page</a> and learn more <a class="smoothscroll" href="#about">about me</a>.</h3>					
					<hr style={{ color: '#FFFFFF' }} />
					<ul class="social">
					   <li><a href="#"><i class="fa fa-facebook"></i></a></li>
					   <li><a href="#"><i class="fa fa-twitter"></i></a></li>
					   <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
					   <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
					   <li><a href="#"><i class="fa fa-instagram"></i></a></li>
					   <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
					   <li><a href="#"><i class="fa fa-skype"></i></a></li>
					</ul>
				 </div>
			 </div>
			
			<p class="scrolldown">
				<a class="smoothscroll" href="#about"><i class="icon-down-circle"></i></a>
			</p>
		</header>	  
	  }     
      </React.Fragment>
    );
  }
}
